/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Article } from '../../models/article';
import { CreateArticleRequest } from '../../models/create-article-request';

export interface CreateArticle$Params {
      body: CreateArticleRequest
}

export function createArticle(http: HttpClient, rootUrl: string, params: CreateArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<Article>> {
  const rb = new RequestBuilder(rootUrl, createArticle.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Article>;
    })
  );
}

createArticle.PATH = '/v0/articles';
